import {
  type UseQueryOptions,
  useQuery,
  type QueryObserverResult,
} from '@tanstack/react-query'

import type { GetWorkerLastUpdatedSlotInformationResponse } from '@front/type/admin'
import type { CustomError } from '@front/type/api'

import { axiosGet } from '../logic/axios/wrappers/axios.get.wrapper'

import { adminSlotsUrl } from './config'

const useGetWorkerSlotsForAdminCalendarKey = `get-worker-last-updated-slot-information`

export const useGetWorkerLastUpdatedSlotInformationQuery = (
  idWorker: number,
  options?: UseQueryOptions<
    GetWorkerLastUpdatedSlotInformationResponse,
    CustomError
  >,
): QueryObserverResult<
  GetWorkerLastUpdatedSlotInformationResponse,
  CustomError
> =>
  useQuery<GetWorkerLastUpdatedSlotInformationResponse, CustomError>({
    queryKey: [useGetWorkerSlotsForAdminCalendarKey, idWorker],
    queryFn: async () =>
      axiosGet<GetWorkerLastUpdatedSlotInformationResponse>(
        `${adminSlotsUrl}/${idWorker}/last-updated-slot`,
      ),
    staleTime: 0,
    ...options,
  })
